
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/riskintel",
      function () {
        return require("private-next-pages/products/riskintel/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/riskintel"])
      });
    }
  